import { CHUNK_SIZE, GCM_TAG_BYTES } from "./constants";

export function deriveChunkIv(baseIv: Uint8Array, partNumber: number): Uint8Array {
  if (baseIv.byteLength !== 12) {
    throw new Error("Base IV must be 12 bytes for AES-GCM.");
  }

  if (!Number.isInteger(partNumber) || partNumber < 1) {
    throw new Error("Part number must be a positive integer.");
  }

  const chunkIv = new Uint8Array(baseIv);
  const view = new DataView(chunkIv.buffer, chunkIv.byteOffset, chunkIv.byteLength);
  view.setUint32(8, partNumber, false);
  return chunkIv;
}

export function getEncryptedChunkSize(plainChunkSize: number): number {
  return plainChunkSize + GCM_TAG_BYTES;
}

export function getChunkCount(fileSize: number, chunkSize = CHUNK_SIZE): number {
  if (fileSize < 0) throw new Error("File size cannot be negative.");
  return fileSize === 0 ? 0 : Math.ceil(fileSize / chunkSize);
}

export function getEncryptedRangeForPart(
  partNumber: number,
  encryptedObjectSize: number,
  chunkSize = CHUNK_SIZE,
): { start: number; end: number } {
  const fixedEncryptedChunkSize = getEncryptedChunkSize(chunkSize);
  const start = (partNumber - 1) * fixedEncryptedChunkSize;
  const end = Math.min(start + fixedEncryptedChunkSize - 1, encryptedObjectSize - 1);

  if (start > end || start >= encryptedObjectSize) {
    throw new Error("Requested part range exceeds encrypted object size.");
  }

  return { start, end };
}

export function sortCompletedParts<T extends { PartNumber: number }>(parts: T[]): T[] {
  return [...parts].sort((a, b) => a.PartNumber - b.PartNumber);
}

export function formatRangeHeader(start: number, end: number): string {
  return `bytes=${start}-${end}`;
}
